import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { bindLeaveTracking, flushLeave, trackPageview } from '../lib/analytics';

// Fires one pageview per route change. Keyed on pathname (plus the search
// query on /search) so tag-filter/pagination query params on other pages
// don't double-count.
function SiteAnalytics() {
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const searchQuery = location.pathname.startsWith('/search')
        ? (params.get('q') || params.get('s') || '').trim()
        : '';

    useEffect(() => {
        bindLeaveTracking();
        // SPA navigation into /old unmounts this component without a route
        // change the tracker can see — flush so time in the legacy app is
        // never attributed to the last public page.
        return () => flushLeave();
    }, []);

    useEffect(() => {
        trackPageview(location.pathname, searchQuery);
    }, [location.pathname, searchQuery]);

    return null;
}

export default SiteAnalytics;
